import React, { useState } from "react";

import translate from "../../services/Translate";
import DstButton from "../DstButton/DstButton";
import CreateCustomFilterPopup from "./CreateCustomFilterPopup/CreateCustomFilterPopup";
import CustomFilterDropdown from "./CustomFilterDropdown/CustomFilterDropdown";
import { CustomFiltersProps } from "./CustomFilters.d";

const CustomFilters = ({
  activeCustomFilter,
  currentFilters,
  defaultFilters,
  disabled,
  language,
  onApplyFilter,
  resetActiveFilterOnDelete = false,
  storageKey,
}: CustomFiltersProps) => {
  const [showCreationPopup, setShowCreationPopup] = useState(false);

  return (
    <React.Fragment>
      <div className="d-flex flex-column gap-2">
        <div className="d-flex align-items-center justify-content-between">
          <span className="xs-regular dark-gray-font text-uppercase">
            {translate(language, "COMPONENTS.CUSTOM_FILTERS.SAVED_FILTERS")}
          </span>
          <DstButton
            btnClass="d-flex align-items-center"
            btnImageBefore={<span className="dst-icon-plus-circle me-1" />}
            clickFunction={() => setShowCreationPopup(true)}
            disabled={disabled}
            value={translate(language, "COMPONENTS.CUSTOM_FILTERS.CREATE_CUSTOM_FILTER")}
            variant="light"
          />
        </div>
        <CustomFilterDropdown
          activeCustomFilter={activeCustomFilter}
          defaultFilters={defaultFilters}
          language={language}
          onApplyFilter={onApplyFilter}
          resetActiveFilterOnDelete={resetActiveFilterOnDelete}
          storageKey={storageKey}
        />
      </div>
      <CreateCustomFilterPopup
        closeModal={() => setShowCreationPopup(false)}
        currentFilters={currentFilters}
        formId={`${storageKey}-form`}
        language={language}
        show={showCreationPopup}
        storageKey={storageKey}
      />
    </React.Fragment>
  );
};

export default CustomFilters;
